import React from "react";
import { Drawer, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
var useStyles = makeStyles(function (theme) {
  return {
    link: {
      textDecoration: "none",
      color: "inherit",
      margin: "12px 0"
    },
    link_selected: {
      textDecoration: "none",
      color: theme.palette.primary.main,
      margin: "12px 0"
    },
    container: {
      width: "200px",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      padding: "0 12px"
    }
  };
});

var DrawerNavigation = function DrawerNavigation(props) {
  // console.log("Drawer Navigation props", props);
  var classes = useStyles();
  var location = useLocation();
  var history = useHistory();

  var checkRoute = function checkRoute(path) {
    return location.pathname.includes(path) ? true : false;
  };

  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: props.anchor || "left",
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, props.routes.map(function (route) {
    return !route.pathname ? /*#__PURE__*/React.createElement(MenuItem, {
      onClick: props.logout
    }, route.name) : /*#__PURE__*/React.createElement(MenuItem, {
      className: checkRoute(route.pathname) ? classes.link_selected : classes.link,
      onClick: function onClick() {
        history.push({
          pathname: route.pathname,
          state: route.state
        });
        props.handleLinkClose(route.value);
      }
    }, route.name);
  })));
};

export { DrawerNavigation };